export default {"src":"/_next/static/media/lumen-logo.64915b04.svg","height":22,"width":153};